<div class="questionary-progress-bar-container">
  <div class="questionary-progress-bar-container__finished" [style.width.%]='percentageOfCompletion'></div>
</div>
